import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Client } from '../model/Client.model';
import { URL_API } from './url.api';
import { Equipment } from '../model/Equipment.model';
import { Visit } from '../model/Visit.model';

@Injectable({
  providedIn: 'root'
})
export class CustumersService {

  constructor(
    private http: HttpClient
  ) { }

  findById(clientId: number): Observable<Client> {
    return this.http.get<Client>(`${URL_API}/customers/${clientId}`);
  }

  save(client: Client): Observable<any> {
    return this.http.post<any>(`${URL_API}/customers`, client);
  }

  update(client: Client): Observable<any> {
    return this.http.put<any>(`${URL_API}/customers/${client.id}`, client);
  }

  delete(client: Client): Observable<any> {
    return this.http.put<any>(`${URL_API}/customers/${client.id}/delete`, client);
  }

  findAll(): Observable<Array<Client>> {
    return this.http.get<Array<Client>>(`${URL_API}/customers`);
  }

  findContactsByClient(client: Client): Observable<Array<Client>> {
    return this.http.get<Array<Client>>(`${URL_API}/customers/${client.id}/contacts`);
  }

  findVisitsByClient(client: Client): Observable<Array<Visit>> {
    return this.http.get<Array<Visit>>(`${URL_API}/customers/${client.id}/visits`);
  }

  findEquipmentsByClient(client: Client): Observable<Array<Equipment>> {
    return this.http.get<Array<Equipment>>(`${URL_API}/customers/${client.id}/equipments`);
  }
  
}
